import { render } from "./SideNav.vue?vue&type=template&id=5a3a61f2&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=5a3a61f2&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3a61f2"]])

export default __exports__